import React, { useEffect } from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormInput } from 'common/components/form/bootstrap';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

const DuplicateForm = ({
    errors,
    filterData,
    handleClickCancel,
    initialValues,
    isSaving,
    mode,
    saveProposal,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleClickSave = (values) => saveProposal(filterData, mode, values);

    return (
        <form>
            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        control={control}
                        label={t('Proposal name')}
                        name="name"
                    />

                    <ShowErrors errors={errors || []} />
                </Grid>
            </Grid>
            <Grid container mt={1}>
                <Grid
                    size="grow"
                    sx={{
                        display: 'flex',
                        flexDirection: { md: 'row', xs: 'column' },
                        justifyContent: { md: 'right', xs: 'center' },
                    }}
                >
                    <Button
                        onClick={handleClickCancel}
                        sx={{
                            mr: { md: 2, xs: 0 },
                            order: { md: 1, xs: 2 },
                            width: { md: 'auto', xs: '100%' },
                        }}
                        variant="text"
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        disabled={isSaving}
                        onClick={handleSubmit(handleClickSave)}
                        sx={{
                            mb: { md: 0, xs: 2 },
                            order: { md: 2, xs: 1 },
                            width: { md: 'auto', xs: '100%' },
                        }}
                        variant="outlined"
                    >
                        {isSaving ? t('Saving').concat('...') : t('Continue')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

DuplicateForm.propTypes = {
    errors: PropTypes.array,
    filterData: PropTypes.object,
    handleClickCancel: PropTypes.func,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
    mode: PropTypes.string,
    saveProposal: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getSaveProposalErrors,
    initialValues: selectors.getInitialValues,
    isSaving: selectors.getIsSavingProposal,
});

const mapDispatchToProps = (dispatch) => ({
    handleClickCancel: () => dispatch(actions.closeModal()),
    saveProposal: (filterData, mode, values) =>
        dispatch(actions.saveProposal(filterData, mode, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateForm);
